import componentHelper from '../../modules/component_helper.js';

angular.module('vastdesk').
  component('campaignActive',  {
    bindings: {
      formName: '@',
      formId: '@',
      isActive: '<',
      sequentialLiabilityApproved: '<'
    },
    template: require("../templates/campaignActive.html"),
    controllerAs: '$campaignActiveCtrl',
    controller: ["$scope",'$rootScope', function($scope, $rootScope) {

      var self = this;
      this.statusOptions = componentHelper.statusOptions();

      $rootScope.$on('sequentialLiabilityChange', function(e, args) {
        self.sequentialLiabilityApproved = args.approved;
        if (!self.sequentialLiabilityApproved) {
          self.isActive = false;
        }
        $scope.$apply();
      });

      this.setStatus = function (status) {
        if (!self.sequentialLiabilityApproved) {
          self.isActive = false;
        } else {
          self.isActive = status;
        }
      };
    }]
});